import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { CategoryGroup, IRegionalEcosystemDataModel } from '../models/veg-wizard-models';

@Injectable({
  providedIn: 'root'
})
export class RegionalEcosystemService {
  logger: any;

  constructor(
    protected http: HttpClient,
    private sessionService: SessionService) {
  }

  getRegionalEcosystems$(activityIds?: number[]): Observable<CategoryGroup[]> {
    const sessionId = this.sessionService.getSessionIdOrError(); 
    let url = `${environment.apiUrl}/session/${encodeURIComponent(sessionId)}/regional-ecosystems`;
    if (activityIds !== undefined) { url = `${url}?`; }
    activityIds && activityIds.forEach(activity => { url += "activityIds=" + encodeURIComponent("" + activity) + "&"; });
    return this.http.get<CategoryGroup[]>(url);
  }

  searchRegionEcosystem$(regionalEcosystemtext: string): Observable<CategoryGroup[]> {
    const url = `${environment.apiUrl}/session/search-regional-ecosystem`;

    return this.http.post<CategoryGroup[]>(url, {
      'sessionKey': this.sessionService.getSessionId() ?? '',
      'regionalEcosystemSearchText': regionalEcosystemtext
    });
  }

  setRegionalEcosystems$(model: IRegionalEcosystemDataModel): Observable<boolean> {
    const sessionId = this.sessionService.getSessionIdOrError();
    const url = `${environment.apiUrl}/session/${encodeURIComponent(sessionId)}/regional-ecosystems`;

    return this.http.post(url, model)
    .pipe(
      catchError((err: HttpErrorResponse) => {
        this.logger.error('setRegionalEcosystems error', err);
        return of(false)
      }),
      map(() => true) // return true, as it should be HttpStatusCode OK
    );
  }
}